import React, { Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import Loader from "./components/Loader";

const App = lazy(() => import("./containers/App"));
const GlobalThemeStyles = lazy(() =>
  import("@120wateraudit/waterworks").then((m) => ({
    default: m.GlobalThemeStyles,
  }))
);

if (import.meta.env.VITE_FULLSTORY_ID) {
  import("@fullstory/browser").then(({ init }) =>
    init({ orgId: import.meta.env.VITE_FULLSTORY_ID! })
  );
}

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.ready.then((registration) => {
    registration.unregister();
  });
}

const container = document.getElementById("root");
if (container) {
  createRoot(container).render(
    <Suspense fallback={<Loader />}>
      <GlobalThemeStyles />
      <App />
    </Suspense>
  );
}
